// assets/cart-drawer-fix.js
(() => {
  // Only run once
  if (window.__cartDrawerFixLoaded) return;
  window.__cartDrawerFixLoaded = true;

  const isAddToCartSubmit = (submitter) => {
    if (!submitter) return false;

    // Common patterns:
    // - <button type="submit" name="add">
    // - <button data-add-to-cart>
    // - <button id="AddToCart">
    const name = (submitter.getAttribute("name") || "").toLowerCase();
    const id = (submitter.getAttribute("id") || "").toLowerCase();

    if (name === "add") return true;
    if (submitter.hasAttribute("data-add-to-cart")) return true;
    if (id.includes("addtocart")) return true;

    // Fallback: if the button text includes "add to cart"
    const text = (submitter.textContent || "").trim().toLowerCase();
    return text.includes("add to cart");
  };

  const openCartDrawer = () => {
    // Broadcast uses <cart-drawer> custom element
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return false;

    // Try common open methods used by themes
    if (typeof drawer.open === "function") {
      drawer.open();
      return true;
    }

    // Fallback: toggle attributes/classes
    drawer.setAttribute("open", "");
    drawer.classList.add("is-open", "active", "open");
    return true;
  };

  const refreshCartSectionsIfPossible = async () => {
    // Some themes re-render sections; we try a safe minimal refresh.
    // If this fails, the drawer can still open; it just might not instantly show the new item.
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      const cart = await res.json();

      // Broadcast/Theme scripts often listen for cart events
      window.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    } catch (e) {
      // no-op
    }
  };

document.addEventListener("submit", async (e) => {
  console.log('CART DRAWER FIX FIRED');
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Only intercept add-to-cart forms
    const action = (form.getAttribute("action") || "").toLowerCase();
    if (!action.includes("/cart/add")) return;

    // Ensure this was triggered by the "Add to cart" button, not "Buy now"
    const submitter = e.submitter; // modern browsers
    if (submitter && !isAddToCartSubmit(submitter)) return;

    // Prevent normal redirect to /cart
    e.preventDefault();

    // Optional: disable the button while processing
    if (submitter) submitter.disabled = true;

    try {
      const formData = new FormData(form);
      const minPurchase =
  parseInt(formData.get('properties[_minimum_purchase]'), 10) || 1;

formData.set('quantity', minPurchase);

      console.log(
  'MIN PURCHASE:',
  formData.get('properties[_minimum_purchase]')
);


      // Ajax add to cart
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json"
        }
      });

      if (!res.ok) {
        // If Shopify returns an error JSON, you can surface it here if needed
        // For now, fall back to cart page
        window.location.href = "/cart";
        return;
      }

      // Let the theme know cart changed + attempt refresh
// Force Broadcast to rebuild cart
document.dispatchEvent(
  new CustomEvent('theme:cart:change', {
    bubbles: true
  })
);

setTimeout(() => {
  document.dispatchEvent(
    new CustomEvent('theme:product:added', {
      bubbles: true
    })
  );
}, 500);
    } finally {
      if (submitter) submitter.disabled = false;
    }
  });
})();

const MIN_ORDER = 26500;

function getEffectiveCartTotal() {
  let total = 0;

  document.querySelectorAll('.cart__item').forEach(item => {
    const price = parseFloat(item.dataset.effectivePrice || 0);
    const qty = parseInt(item.dataset.quantity || 1);

    total += price * qty;
  });

  return total * 100; // convert dollars to cents
}

function validateMinimumOrder() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      // Cart Drawer
      const drawerBtn = document.querySelector(
        'cart-drawer .cart__checkout'
      );
      const drawerWarning = document.getElementById(
        'cart-minimum-warning'
      );

      // Cart Page
      const pageBtn = document.querySelector(
        '.cart__aside .cart__checkout[name="checkout"]'
      );
      const pageWarning = document.getElementById(
        'cart-page-minimum-warning'
      );

    const effectiveTotal = getEffectiveCartTotal();

const remaining = (
  (MIN_ORDER - effectiveTotal) / 100
).toFixed(2);

      // DRAWER
      if (drawerBtn) {
        if (effectiveTotal < MIN_ORDER) {
          drawerBtn.disabled = true;

          if (drawerWarning) {
            drawerWarning.innerHTML = `
              <div class="cart-minimum-warning">
                Minimum order amount is AUD $265. You need $${remaining} more before checkout.
              </div>
            `;
          }
        } else {
          drawerBtn.disabled = false;

          if (drawerWarning) {
            drawerWarning.innerHTML = '';
          }
        }
      }

      // CART PAGE
      if (pageBtn) {
        if (effectiveTotal < MIN_ORDER) {
          pageBtn.disabled = true;

          if (pageWarning) {
            pageWarning.innerHTML = `
              <div class="cart-minimum-warning">
                Minimum order amount is AUD $265. You need $${remaining} more before checkout.
              </div>
            `;
          }
        } else {
          pageBtn.disabled = false;

          if (pageWarning) {
            pageWarning.innerHTML = '';
          }
        }
      }
    });
}

document.addEventListener('theme:cart:change', () => {
  setTimeout(validateMinimumOrder, 300);
});

document.addEventListener('cart:updated', () => {
  setTimeout(validateMinimumOrder, 300);
});

document.addEventListener('change', () => {
  setTimeout(validateMinimumOrder, 300);
});


validateMinimumOrder();